// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ROOT VARIABLES
 * Define common values for easy maintenance.
 */
:root {
  --primary-color: #1890ff;
  --primary-color-dark: #438f90;
  --light-gray: #f9f9f9;
  --medium-gray: #eee;
  --dark-gray: #303030;
  --text-color-dark: #333;
  --text-color-light: #fff;
  --text-color-medium: #666;
  --success-color: #5cb85c;
  --pending-color: #f0ad4e;
  --border-radius: 12px;
  --shadow-base: 0 4px 12px rgba(0, 0, 0, 0.1);
  --shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/*
 * VIEW ORDERS PAGE LAYOUT
 * Sets the main layout for the orders page and grid container.
 */
.orders-page-layout {
  grid-column: 2;
  grid-row: 2;
  padding: 30px 10px;
  background-color: var(--dark-gray);
  overflow-y: auto;
}

/*
 * ORDER CARD STYLING
 * Styling for individual order cards in the grid.
 */
.order-cards-grid {
  /* This selector applies to the grid that holds all the cards. */
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    padding: 40px 20px;
}

.order-card {
  background-color: var(--text-color-light);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow-base);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.order-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-hover);
}

.order-card-selected {
  border: 2px solid var(--primary-color);
  box-shadow: 0 0 0 3px rgba(80, 163, 164, 0.5);
}

.order-card-content {
  padding: 1rem;
}

/* Order Header within the card */
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 20px;
}

.order-id {
  font-size: 1.25rem;
  font-weight: bold;
  color: var(--text-color-dark);
  margin: 0;
}

/* Order Status Badge */
.order-status {
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: capitalize;
  color: var(--text-color-light);
}

.order-status-completed {
  background-color: var(--success-color);
}

.order-status-pending {
  background-color: var(--pending-color);
}

/* Detailed information within the card */
.details-order p {
  margin: 0.5rem 0;
  color: var(--text-color-medium);
  font-size: 0.95rem;
}

.detail-label {
  font-weight: 600;
  color: var(--text-color-dark);
}

.order-value {
  color: var(--primary-color);
  font-weight: bold;
}

/*
 * EMPTY STATE STYLING
 * Styles for when there are no orders to display.
 */
.no-orders-message {
  text-align: center;
  grid-column: 1 / -1;
  color: #888;
  padding: 3rem;
}

.no-orders-message p {
  margin: 0.5rem 0;
}

.no-orders-message .text-xl {
  font-size: 1.5rem;
  font-weight: bold;
}

.no-orders-message .text-md {
  font-size: 1rem;
}

/*
 * ORDER DETAILS OVERLAY AND PANE
 * Styles for the modal that shows detailed order information.
 */
.order-details-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-out;
}

.order-details-pane {
  background-color: var(--text-color-light);
  padding: 2rem;
  border-radius: var(--border-radius);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
  max-height: 70%;
  overflow-y: auto;
  position: relative;
  transform: translateY(0);
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

/* Header of the details pane */
.details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid var(--medium-gray);
  padding-bottom: 1rem;
}

.details-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--text-color-dark);
  margin: 0;
}

/* Close button for the details pane */
.close-details-button {
  background-color: var(--primary-color);
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  color: var(--text-color-light);
  font-weight: bold;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* position: absolute; */
  top: 1rem;
  right: 1rem;
  z-index: 10;
  transition: background-color 0.2s ease;
}

.close-details-button:hover {
  background-color: var(--primary-color-dark);
}

/*
 * LICENSE LIST STYLING
 * Styles for the list of licenses within the details pane.
 */
.license-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.license-item {
  background-color: var(--light-gray);
  border-left: 4px solid var(--primary-color);
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.license-product-name {
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--text-color-dark);
  margin-top: 0;
  margin-bottom: 0.75rem;
}

.license-codes {
  list-style: none;
  padding: 0;
  margin: 0;
  color: black;
}

.license-code-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
}

.license-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1 1;
  word-break: break-all;
  color: black;
}

.code-value {
  margin-left: 8px; /* Adjust this value to control the gap size */
  font-weight: 500;
  font-size: 20px;
}

.license-duration {
  font-size: 0.9rem;
  color: #777;
  background-color: #eef;
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  margin-left: 1rem;
  white-space: nowrap;
}

/*
 * LOADING AND ERROR STATES
 * Styles for messages that appear when content is loading or has an error.
 */
.loading-message,
.error-message {
  text-align: center;
  color: #777;
  font-size: 1rem;
  padding: 1rem;
}

.orders-loading-state,
.orders-error-state {
  text-align: center;
  padding: 3rem;
  width: 100%;
}

/*
 * MOBILE LAYOUT
 * Adjustments for screens up to 768px wide.
 */
@media (max-width: 768px) {

  .order-details-pane {
    width: 85%;
    padding: 15px;
  }
  
}

/* --- Retry Payment Box Styles --- */
.retry-payment-box {
  margin-bottom: 15px;
  padding: 12px 16px;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.retry-payment-text {
  color: #856404;
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}

.retry-payment-btn {
  background-color: #ffc107;
  color: #212529;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: background-color 0.2s ease-in-out, transform 0.1s ease;
}

.retry-payment-btn:hover {
  background-color: #e0a800;
}

.retry-payment-btn:active {
  transform: scale(0.98);
}

/*
 * ANIMATIONS
 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/ViewOrder.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;;;EAGE;AACF;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;EAGE;AACF;EACE,gEAAgE;IAC9D,aAAa;IACb,SAAS;IACT,4DAA4D;IAC5D,kBAAkB;AACtB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,8BAA8B;EAC9B,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;;EAGE;AACF;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE;AACF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,mCAAmC;EACnC,yCAAyC;EACzC,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;EAGE;AACF;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAO;EACP,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB,EAAE,8CAA8C;EAChE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE;AACF;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE;AACF;;EAEE;IACE,UAAU;IACV,aAAa;EACf;;AAEF;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE;AACF;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/*\n * ROOT VARIABLES\n * Define common values for easy maintenance.\n */\n:root {\n  --primary-color: #1890ff;\n  --primary-color-dark: #438f90;\n  --light-gray: #f9f9f9;\n  --medium-gray: #eee;\n  --dark-gray: #303030;\n  --text-color-dark: #333;\n  --text-color-light: #fff;\n  --text-color-medium: #666;\n  --success-color: #5cb85c;\n  --pending-color: #f0ad4e;\n  --border-radius: 12px;\n  --shadow-base: 0 4px 12px rgba(0, 0, 0, 0.1);\n  --shadow-hover: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n/*\n * VIEW ORDERS PAGE LAYOUT\n * Sets the main layout for the orders page and grid container.\n */\n.orders-page-layout {\n  grid-column: 2;\n  grid-row: 2;\n  padding: 30px 10px;\n  background-color: var(--dark-gray);\n  overflow-y: auto;\n}\n\n/*\n * ORDER CARD STYLING\n * Styling for individual order cards in the grid.\n */\n.order-cards-grid {\n  /* This selector applies to the grid that holds all the cards. */\n    display: grid;\n    gap: 30px;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    padding: 40px 20px;\n}\n\n.order-card {\n  background-color: var(--text-color-light);\n  border-radius: var(--border-radius);\n  box-shadow: var(--shadow-base);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.order-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-hover);\n}\n\n.order-card-selected {\n  border: 2px solid var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(80, 163, 164, 0.5);\n}\n\n.order-card-content {\n  padding: 1rem;\n}\n\n/* Order Header within the card */\n.order-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  gap: 20px;\n}\n\n.order-id {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: var(--text-color-dark);\n  margin: 0;\n}\n\n/* Order Status Badge */\n.order-status {\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  color: var(--text-color-light);\n}\n\n.order-status-completed {\n  background-color: var(--success-color);\n}\n\n.order-status-pending {\n  background-color: var(--pending-color);\n}\n\n/* Detailed information within the card */\n.details-order p {\n  margin: 0.5rem 0;\n  color: var(--text-color-medium);\n  font-size: 0.95rem;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: var(--text-color-dark);\n}\n\n.order-value {\n  color: var(--primary-color);\n  font-weight: bold;\n}\n\n/*\n * EMPTY STATE STYLING\n * Styles for when there are no orders to display.\n */\n.no-orders-message {\n  text-align: center;\n  grid-column: 1 / -1;\n  color: #888;\n  padding: 3rem;\n}\n\n.no-orders-message p {\n  margin: 0.5rem 0;\n}\n\n.no-orders-message .text-xl {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.no-orders-message .text-md {\n  font-size: 1rem;\n}\n\n/*\n * ORDER DETAILS OVERLAY AND PANE\n * Styles for the modal that shows detailed order information.\n */\n.order-details-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.order-details-pane {\n  background-color: var(--text-color-light);\n  padding: 2rem;\n  border-radius: var(--border-radius);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 600px;\n  max-height: 70%;\n  overflow-y: auto;\n  position: relative;\n  transform: translateY(0);\n  transition: transform 0.3s ease-out, opacity 0.3s ease-out;\n}\n\n/* Header of the details pane */\n.details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid var(--medium-gray);\n  padding-bottom: 1rem;\n}\n\n.details-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--text-color-dark);\n  margin: 0;\n}\n\n/* Close button for the details pane */\n.close-details-button {\n  background-color: var(--primary-color);\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  color: var(--text-color-light);\n  font-weight: bold;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* position: absolute; */\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n  transition: background-color 0.2s ease;\n}\n\n.close-details-button:hover {\n  background-color: var(--primary-color-dark);\n}\n\n/*\n * LICENSE LIST STYLING\n * Styles for the list of licenses within the details pane.\n */\n.license-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.license-item {\n  background-color: var(--light-gray);\n  border-left: 4px solid var(--primary-color);\n  border-radius: 8px;\n  padding: 1.25rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.license-product-name {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--text-color-dark);\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n}\n\n.license-codes {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  color: black;\n}\n\n.license-code-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.license-info {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  flex: 1;\n  word-break: break-all;\n  color: black;\n}\n\n.code-value {\n  margin-left: 8px; /* Adjust this value to control the gap size */\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.license-duration {\n  font-size: 0.9rem;\n  color: #777;\n  background-color: #eef;\n  padding: 0.25rem 0.6rem;\n  border-radius: 12px;\n  margin-left: 1rem;\n  white-space: nowrap;\n}\n\n/*\n * LOADING AND ERROR STATES\n * Styles for messages that appear when content is loading or has an error.\n */\n.loading-message,\n.error-message {\n  text-align: center;\n  color: #777;\n  font-size: 1rem;\n  padding: 1rem;\n}\n\n.orders-loading-state,\n.orders-error-state {\n  text-align: center;\n  padding: 3rem;\n  width: 100%;\n}\n\n/*\n * MOBILE LAYOUT\n * Adjustments for screens up to 768px wide.\n */\n@media (max-width: 768px) {\n\n  .order-details-pane {\n    width: 85%;\n    padding: 15px;\n  }\n  \n}\n\n/* --- Retry Payment Box Styles --- */\n.retry-payment-box {\n  margin-bottom: 15px;\n  padding: 12px 16px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeeba;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.retry-payment-text {\n  color: #856404;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.retry-payment-btn {\n  background-color: #ffc107;\n  color: #212529;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: background-color 0.2s ease-in-out, transform 0.1s ease;\n}\n\n.retry-payment-btn:hover {\n  background-color: #e0a800;\n}\n\n.retry-payment-btn:active {\n  transform: scale(0.98);\n}\n\n/*\n * ANIMATIONS\n */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
